import { render, staticRenderFns } from "./aTHINKTab.vue?vue&type=template&id=1e3e5e00&scoped=true&"
import script from "./aTHINKTab.vue?vue&type=script&lang=js&"
export * from "./aTHINKTab.vue?vue&type=script&lang=js&"
import style0 from "./aTHINKTab.vue?vue&type=style&index=0&id=1e3e5e00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3e5e00",
  null
  
)

export default component.exports